// btw-front/src/components/admin/dashboard/shared.jsx
// 관리자 대시보드 탭들이 공유하는 소형 프리미티브·헬퍼(named export).
import React from "react";

export function formatKRW(n) {
  return new Intl.NumberFormat("ko-KR").format(n || 0);
}

// 딜 클릭 이동 경로 — 본인이 등록한 관리자 딜만 수정 페이지로, 그 외(파트너 딜·타 관리자
// 딜)는 상세 페이지로. 타 관리자 딜도 열람·내부 메모·삭제가 가능해야 하므로 수정 페이지
// (진입 시 소유자 가드로 되돌려보냄)로 보내지 않는다.
export function dealClickPath(d, adminUserId) {
  const isMine = d.isAdminCreated && String(d.createdByAdminId) === String(adminUserId);
  return isMine ? `/admin/deals/${d.id}/edit` : `/partners/deals/${d.id}`;
}

// 정렬 가능한 테이블 헤더 — 클릭 시 오름↔내림 토글, 활성 컬럼에만 방향 강조.
// sort: { key, dir } | null, onToggle: (key) => void
export function SortTh({ sort, onToggle, sortKey, label, align = "left" }) {
  const active = !!sort && sort.key === sortKey;
  const arrow = active ? (sort.dir === "asc" ? "▲" : "▼") : "↕";
  return (
    <th
      className={`whitespace-nowrap px-4 py-2.5 font-medium ${align === "right" ? "text-right" : "text-left"}`}
    >
      <button
        type="button"
        onClick={() => onToggle(sortKey)}
        className={`inline-flex items-center gap-1 uppercase tracking-wider transition hover:text-slate-700 ${align === "right" ? "flex-row-reverse" : ""}`}
      >
        {label}
        <span className={`text-[10px] ${active ? "text-accent" : "text-slate-300"}`}>{arrow}</span>
      </button>
    </th>
  );
}

// 상태 필터 칩 — PartnerDashboard 의 Tabs 와 동일 패턴
export function Tabs({ value, onChange, items }) {
  return (
    <div className="flex flex-wrap gap-1">
      {items.map((it) => (
        <button
          key={it.key}
          type="button"
          onClick={() => onChange(it.key)}
          className={`rounded-full px-3 py-1.5 text-xs font-medium transition ${
            value === it.key
              ? "bg-slate-900 text-white"
              : "bg-white text-slate-600 hover:bg-slate-100"
          }`}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}

// 일괄 발송 팝업 체크박스 공통 클래스
export const bulkCheckboxCls = "h-4 w-4 rounded border-slate-300 text-accent focus:ring-accent/40";

// 정체 일수 강조 톤 — 60일 이상 rose, 30일 이상 amber ([관리 대상 딜] 목록·일괄 발송 팝업 공용)
export const stallTone = (n) =>
  n >= 60 ? "text-rose-600" : n >= 30 ? "text-amber-600" : "text-slate-700";

export const pad2 = (n) => String(n).padStart(2, "0");
